import environment from '@/environment';
import { createHeaders, handleResponse } from '@/api/api-utils';
import { quoteState as quoteStateSchema, type QuoteState } from '@/schemas/quoteResponseSchema';

export const updateCoverage = async (
  quoteState: Pick<QuoteState, 'coverages'>,
  options?: { signal?: AbortSignal }
): Promise<QuoteState> => {
  const payload = {
    quote_state: {
      coverages: quoteState.coverages,
    },
  };

  const response = await fetch(`${environment.serverBaseUrl}/coverage/update`, {
    method: 'POST',
    headers: createHeaders(),
    body: JSON.stringify(payload),
    signal: options?.signal,
  });

  const responseData = await handleResponse(response);

  return quoteStateSchema.parse(responseData);
};
